export const JOIN_TEAM = {
  name: 'jointeam',
  path: '/jointeam',
};

export const ONBOARDING = {
  name: 'onboarding',
  path: '/onboarding?survey_template_id&signup_method&c',
};
